import React, { useContext } from 'react';
import { MeasurementDate, SecurityModel } from 'api';
import { CapTableVersion } from 'common/types/company';
import { Fund } from 'common/types/fund/fund';
import { FundOwnership } from 'common/types/fundOwnership';
import { FieldAttribute } from 'common/types/store';
import { OptionType } from 'components/CustomSelect/types';
import { FundOwnershipTableData } from 'pages/CapTable/fund-ownership/models/fund-ownership.models';
import { FundOwnershipCapTable } from 'pages/CapTable/fund-ownership/types';


export interface FundOwnershipContextType {
  isDisabled?: boolean;
  measurementDate: string;
  validSecurities: SecurityModel[];
  tableData: FundOwnershipTableData;
  selectedMeasurementDate?: MeasurementDate;
  fundList?: Fund[];
  capTableVersionsByCompany: Record<string, CapTableVersion[]>;
  setFundEntityListValues: (value: OptionType[], columnLegend: string) => void;
  fundEntityListValues: { [key: string]: OptionType[] };
  setSecurityListValues: (value: OptionType[], columnLegend: string) => void;
  securityListValues: { [key: string]: OptionType[] };
  spreadsheetTableData?: Partial<FundOwnershipTableData>;
  fieldAttributes?: Map<string, FieldAttribute>;
}

const FundOwnershipContext = React.createContext<FundOwnershipContextType>({
  securityListValues: {},
  setSecurityListValues: () => {},
  capTableVersionsByCompany: {},
  fundEntityListValues: {},
  setFundEntityListValues: () => {},
  spreadsheetTableData: {},
  fieldAttributes: new Map(),
  measurementDate: '',
  validSecurities: [],
  tableData: {
    acquisitions: [],
    capTable: {} as FundOwnershipCapTable,
    fundOwnership: {} as FundOwnership & { deleted_fund_ownership_details: number[] },
    capTableVersionsByCompany: {},
  },
});

export const useFundOwnershipContext = () => useContext(FundOwnershipContext);

export default FundOwnershipContext;
